import React, { useContext, useState } from "react";
import '../../styles/filterComponents.css';
import '../../styles/filterList.css';
import '../../styles/customFilter.css';
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import IndustryFilter from "../../Components/RefineSearchComponents/IndustryFilter";
import SectorFilter from "../../Components/RefineSearchComponents/PESectorFilter";
import StageFilter from "../../Components/RefineSearchComponents/StageFilter";
import RoundFilter from "../../Components/RefineSearchComponents/RoundFilter";
import CompanyTypeFilter from "../../Components/RefineSearchComponents/CompanyTypeFilter";
import YearFoundedFilter from "../../Components/RefineSearchComponents/YearFoundedFilter";
import DealTypeFilter from "../../Components/RefineSearchComponents/DealTypeFilter";
import SyndicationFilter from "../../Components/RefineSearchComponents/SyndicationFilter";
import DealsInvolvingFilter from "../../Components/RefineSearchComponents/DealsInvolvingFilter";
import CountryFilter from "../../Components/RefineSearchComponents/CountryFilter";
import RegionFilter from "../../Components/RefineSearchComponents/RegionFilter";
import StateFilter from "../../Components/RefineSearchComponents/StateFilter";
import CityFilter from "../../Components/RefineSearchComponents/CityFilter";
import InvestorTypeFilter from "../../Components/RefineSearchComponents/InvestorTypeFilter";
import InvestorHeadquartersFilter from "../../Components/RefineSearchComponents/InvestorHeadquartersFilter";
import DealRangeFilter from "../../Components/RefineSearchComponents/DealRangeFilter";
import ExitStatusFilter from "../../Components/RefineSearchComponents/ExitStatusFilter";
import ValuationFilter from "../../Components/RefineSearchComponents/ValuationFilter";
import FirmTypeFilter from "../RefineSearchComponents/FirmTypeFilter";
import Switch from "../RefineSearchComponents/AndOrToggleSwtich";
import Tags from "../RefineSearchComponents/Tags";
import { useLocation, useNavigate } from "react-router";
import { useEffect } from "react";
import axios from "axios";
import { filterLocationUrl, filterSectorByIndutry, refineSearchSubFirmTypeUrl, tagList, tagSearchUrl } from "../../Config/config";
import { UserContext } from "../../Contexts/UserContext";
import { TableDataContext } from "../../Contexts/TableDataContext";
import Constants from "../../Constants";
import { FaInfoCircle } from "react-icons/fa"
import { Modal, Tooltip } from "antd";
import DefinitionModal from "../TagDefinitionModal";
import useModule from "../../hooks/useModule";
import ToggleButton from "../RefineSearchComponents/ToggleAndOrSwitch";
import LAdvisor from '../RefineSearchComponents/lAdvisor';
import TAdvisor from '../RefineSearchComponents/tAdvisor';
import TargetCompany from '../RefineSearchComponents/TargetCompany';
import Investor from "../RefineSearchComponents/Investor";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import FirmTypeSubMenu from "../RefineSearchComponents/FirmTypeSubMenu";

/**
 * The component renders a form for refining search filters.
 * @returns a JSX element.
 */
export default function InvestmentRefineSearch({ customPathname, menu, generalPathname }) {
    const {
        dbDropdown, setDbDropdown, isMobile,
        onErrorHandler, open, setOpen,
        refineSearchFilters, SwitchState, setSwitchState, dropdown, Sectors, setSectors,
        InvestorOptions, setInvestorOptions, dealsView, checkToggleBtn, setToggleDealsBtn,
        lAdvisorsOptions, setlAdvisorsOptions, tAdvisorsOptions, settAdvisorsOptions, TargetCompanyOptions, setTargetCompanyOptions, AllCities,
        setrefineSearchFilters, setMonthPickerValue, HeadquarterCityOptions, setHeadquarterCityOptions, selectedInvestorHeadquartersCity, setSelectedInvestorHeadquartersCity, setSubFirmType, accessControl, getSectorByIndustry, setDropdown } = useContext(PeFilterContext);

    // Force dropdown to be open by default
    useEffect(() => {
        setDropdown(true);
    }, []);
    const { setCurrentPage } = useContext(TableDataContext);
    const [select, setSelected] = useState(32);
    const navigate = useNavigate();
    const { getToken } = useContext(UserContext);
    const location = useLocation();
    const { pathname } = useLocation();
    const isFromGlobalSearch = () => refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const isFromSearchedList = () => refineSearchFilters[location?.state?.prevPath]?.globalSearch?.length > 0 ? true : false
    const isFromGroupList = () => refineSearchFilters[location.pathname]?.myList?.length > 0 ? true : false


    //local updated options
    const [IndustriesOptions, setIndustriesOptions] = useState([])
    const [SectorOptions, setSectorOptions] = useState([])
    const [StageOptions, setStageOptions] = useState([])
    const [RoundOptions, setRoundOptions] = useState([])
    const [CompanyTypeOptions, setCompanyTypeOptions] = useState([])
    const [EndYearOptions, setEndYearOptions] = useState([]);
    const [StartYearOptions, setStartYearOptions] = useState([])
    const [DealTypeOption, setDealTypeOption] = useState([]);
    const [SyndicationOptions, setSyndicationOptions] = useState([])
    const [DealsInvolvingOptions, setDealsInvolvingOptions] = useState([])
    const [CountryOptions, setCountryOptions] = useState([])
    const [RegionOptions, setRegionOptions] = useState([])
    const [StateOptions, setStateOptions] = useState([])
    const [CityOptions, setCityOptions] = useState([])
    const [InvestorTypeOptions, setInvestorTypeOptions] = useState([])
    const [HeadquartersOptions, setHeadquartersOptions] = useState([])
    const [FirmTypeOptions, setFirmTypeOptions] = useState([])
    const [FirmSubTypeOptions, setFirmSubTypeOptions] = useState([])
    const [DealRange, setDealRange] = useState({ from: "", to: "" })
    const [ExitStatusOptions, setExitStatusOptions] = useState([])
    const [ValuationOptions, setValuationOptions] = useState([])
    const [TagSwitchState, setTagSwitchState] = useState(true)
    const [TagsOptions, setTagsOptions] = useState([])

    // State for managing which filter section is active
    const [activeFilterSection, setActiveFilterSection] = useState("keyword");

    // State for managing which individual filter popup is open
    const [openFilterPopup, setOpenFilterPopup] = useState(null);

    // Initialize filter counts from refineSearchFilters on mount
    useEffect(() => {
        // Initialize Deal Range if it exists in refineSearchFilters
        const savedDealRange = refineSearchFilters[customPathname]?.dealRange;
        if (savedDealRange && savedDealRange.length === 2) {
            setDealRange({
                from: savedDealRange[0]?.name || "",
                to: savedDealRange[1]?.name || ""
            });
        }
    }, [customPathname, refineSearchFilters]);

    // Helper functions to count applied filters for each section
    const getDealFiltersCount = () => {
        const hasStage = StageOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasRound = RoundOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasDealType = DealTypeOption?.some(option => option.isChecked) ? 1 : 0;
        const hasSyndication = SyndicationOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasDealsInvolving = DealsInvolvingOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasDealRange = (DealRange?.from !== "" && DealRange?.to !== "") ? 1 : 0;
        const hasExitStatus = ExitStatusOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasValuation = ValuationOptions?.some(option => option.isChecked) ? 1 : 0;

        return hasStage + hasRound + hasDealType + hasSyndication + hasDealsInvolving + hasDealRange + hasExitStatus + hasValuation;
    };

    const getCompanyFiltersCount = () => {
        const hasIndustry = IndustriesOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasSector = SectorOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasCompanyType = CompanyTypeOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasYearFounded = (StartYearOptions?.some(option => option.isChecked) || EndYearOptions?.some(option => option.isChecked)) ? 1 : 0;
        const hasCountry = CountryOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasRegion = RegionOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasState = StateOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasCity = CityOptions?.some(option => option.isChecked) ? 1 : 0;

        return hasIndustry + hasSector + hasCompanyType + hasYearFounded + hasCountry + hasRegion + hasState + hasCity;
    };

    const getInvestorFiltersCount = () => {
        const hasInvestorType = InvestorTypeOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasHeadquarters = HeadquartersOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasHeadquarterCity = HeadquarterCityOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasFirmType = FirmTypeOptions?.some(option => option.isChecked) ? 1 : 0;
        // const hasFirmSubType = FirmSubTypeOptions?.some(option => option.isChecked) ? 1 : 0;

        return hasInvestorType + hasHeadquarters + hasHeadquarterCity + hasFirmType;
    };

    const getKeywordFiltersCount = () => {
        const hasTagFilters = TagsOptions?.some(tag => tag.isChecked) ? 1 : 0;
        const hasInvestor = InvestorOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasTargetCompany = TargetCompanyOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasLAdvisor = lAdvisorsOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasTAdvisor = tAdvisorsOptions?.some(option => option.isChecked) ? 1 : 0;

        return hasTagFilters + hasInvestor + hasTargetCompany + hasLAdvisor + hasTAdvisor;
    };

    const applyFilter = () => {
        const selectedIndustries = IndustriesOptions.filter(industry => industry.isChecked);
        const selectedSectors = SectorOptions.filter(option => option.isChecked);
        const selectedStages = StageOptions.filter(option => option.isChecked);
        const selectedRounds = RoundOptions.filter(option => option.isChecked);
        const selectedCompanyType = CompanyTypeOptions?.filter(option => option.isChecked);
        const selectedStartYear = StartYearOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedEndYear = EndYearOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedDealType = DealTypeOption?.filter(option => option.isChecked);
        const selectedSynd = SyndicationOptions?.filter(option => option.isChecked);
        const selectedDealInvolving = DealsInvolvingOptions?.filter(option => option.isChecked);
        const selectedCountries = CountryOptions?.filter(option => option.isChecked);
        const selectedRegion = RegionOptions?.filter(option => option.isChecked);
        const selectedState = StateOptions?.filter(option => option.isChecked);
        const selectedCity = CityOptions?.filter(option => option.isChecked);
        const selectedInvestorType = InvestorTypeOptions?.filter(option => option.isChecked);
        const selectedHeadCity = HeadquarterCityOptions?.filter(option => option.isChecked);
        const selectedHead = HeadquartersOptions?.filter(option => option.isChecked);
        const selectedHeadNames = selectedHeadCity.map(option => option.name);
        const selectedFirm = FirmTypeOptions?.filter(option => option.isChecked);
        const selectedFirmSubTypes = FirmSubTypeOptions?.filter(option => option.isChecked);
        const selectedExitStatus = ExitStatusOptions?.filter(option => option.isChecked);
        const selectedValuations = ValuationOptions?.filter(option => option.isChecked);
        const selectedOperators = SwitchState;
        const selectedlAdvisors = lAdvisorsOptions?.filter(option => option.isChecked);
        const selectedtAdvisors = tAdvisorsOptions?.filter(option => option.isChecked);
        const selectedTargetCompany = TargetCompanyOptions?.filter(option => option.isChecked);
        const selectedInvestor = InvestorOptions?.filter(option => option.isChecked);

        checkToggleBtn();
        setSelectedInvestorHeadquartersCity(HeadquarterCityOptions?.filter(option => option.isChecked));
        const firmTypeNames = selectedFirm?.filter(firm => firm.isChecked).map(firm => firm.name) ?? [];
        let filteredFirmSubTypes = null;

        const excludedNames = ['Healthcare(PE)', 'Cleantech(PE)', 'Healthcare(VC)', 'Cleantech(VC)'];

        if (firmTypeNames.includes('PE') || firmTypeNames.includes('VC')) {
            filteredFirmSubTypes = selectedFirmSubTypes?.filter(sub => {
                const isPE = sub.name?.includes('(PE)') || sub.originalName?.includes('(PE)');
                const isVC = sub.name?.includes('(VC)') || sub.originalName?.includes('(VC)');

                if (firmTypeNames.includes('PE') && firmTypeNames.includes('VC')) {
                    return isPE || isVC;
                } else if (firmTypeNames.includes('PE')) {
                    return isPE;
                } else if (firmTypeNames.includes('VC')) {
                    return isVC;
                }
                return false;
            })?.map(sub => {
                if (!excludedNames.includes(sub.name)) {
                    return {
                        ...sub,
                        name: sub.name.replace(/\((PE|VC)\)/, ''),
                    };
                }
                return sub;
            }) ?? null;

            if (filteredFirmSubTypes.length === 0) {
                filteredFirmSubTypes = null;
            }
        }

        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]: {
                ...prev[generalPathname],
                industry: selectedIndustries,
                sector: selectedSectors,
                countries: selectedCountries,
                region: selectedRegion,
                yearFounded: selectedEndYear != null && selectedStartYear != null ? [selectedStartYear, selectedEndYear] : [],
                state: selectedState,
                city: selectedCity,
                investorType: selectedInvestorType,
                investorHeadquarters: selectedHead,
                investor_headquaters_city: selectedHeadCity,
                firmType: selectedFirm,
                firm_Sub_type: filteredFirmSubTypes,
                operator: TagSwitchState ? 1 : 0,
                tags: TagsOptions,
                deals_operator: selectedOperators,
                ladvisors: selectedlAdvisors,
                tadvisors: selectedtAdvisors,
                investor_id: selectedInvestor,
                target_company: selectedTargetCompany,
            },
            [customPathname]: {
                ...prev[customPathname],
                stage: selectedStages,
                exitStatus: selectedExitStatus,
                round: selectedRounds,
                companyType: selectedCompanyType,
                dealType: selectedDealType,
                syndication: selectedSynd,
                dealsInvolving: selectedDealInvolving,
                dealRange: DealRange?.from != "" && DealRange?.to != "" ? [{ id: 0, name: DealRange?.from }, { id: 1, name: DealRange?.to }] : [],
                valuations: selectedValuations,
                // myList:isFromGroupList()? Object.keys(refineSearchFilters[location.pathname] ?? {}).map((filter) => {
                //     let tagList = [];
                //     tagList = refineSearchFilters[location.pathname][filter];
                //     return [{id:0,name:tagList?.name, group_id:tagList?.group_id}]

                // }):null

            },
        }))
    }

    const resetDealsByFilter = () => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]: {},
            [customPathname]: {}
        }))
        setHeadquarterCityOptions(HeadquarterCityOptions.map(option => {
            if (option.isChecked) {
                return { ...option, isChecked: false };
            }
            return option;
        }));
        setlAdvisorsOptions([]);
        settAdvisorsOptions([]);
        setTargetCompanyOptions([]);
        setInvestorOptions([]);
        setSectors([]);
        setToggleDealsBtn(true);
    }

    useEffect(() => {
        setToggleDealsBtn(true);
    }, [customPathname])



    //  console.log(InvestorOptions , "jjjij")
    // Submitting Refine Search Form 
    const refineSearchFilter = (event) => {
        if (isMobile) {
            setOpen(!open);
        }
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]: {},
            [customPathname]: {
                globalSearch: [],
            }
        }))
        // console.log(refineSearchFilters, "genr")
        if (isFromGlobalSearch() || isFromSearchedList()) {
            setMonthPickerValue(Constants.initialMonthRange)
        }
        event.preventDefault();
        setCurrentPage(1);
        // if (isMatch == null || isCompanyMatch != null) {
        //     navigate(routeNames.pe_companies_pe_vc_investments);
        // }
        applyFilter();
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
        setSelected(false)

    }

    const onResetClick = (event) => {

        event.preventDefault();
        setCurrentPage(1);
        // if (isMatch == null || isCompanyMatch != null) {
        //     navigate(routeNames.pe_companies_pe_vc_investments);
        // }
        resetDealsByFilter()
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }

    const accordionClick = (val) => {
        if (val == select) {
            setSelected(0);
        } else {
            setSelected(val);
        }
    };

    const onCountryChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            country: ids,
            region: [],
            state: [],
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status == 200) {
                setRegionOptions(response.data?.region)
                setStateOptions(response.data.state)
                setCityOptions(response.data?.city)
            }
        }).catch(onErrorHandler)
    }

    const onRegionChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        const selectedCountries = CountryOptions?.filter(option => option.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            country: selectedCountries,
            region: ids,
            state: [],
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status == 200) {
                setStateOptions(response.data.state)
                setCityOptions(response.data?.city)
            }
        }).catch(onErrorHandler)
    }

    const onStateChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        const selectedCountries = CountryOptions?.filter(option => option.isChecked)?.map(option => option.id);
        const selectedRegion = RegionOptions?.filter(option => option.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            country: selectedCountries,
            region: selectedRegion,
            state: ids,
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status == 200) {
                setCityOptions(response.data?.city)
            }
        }).catch(onErrorHandler)
    }


    useEffect(() => {
        const ids = IndustriesOptions?.length > 0 ?
            IndustriesOptions.filter(industry => industry.isChecked)?.map(option => option.id) : [];

        if (ids?.length > 0) {
            getSectorByIndustry(ids, "investments")
        } else {
            setSectors([])
        }

    }, [IndustriesOptions])

    useEffect(() => {
        if (accessControl?.peindustries?.id?.length > 0) {
            const ids = accessControl ? accessControl?.peindustries?.id : []
            getSectorByIndustry(ids, "investments")
        }
    }, [])



    // console.log(AllCities,"khhgjh")
    useEffect(() => {
        const countryIds = refineSearchFilters[generalPathname]?.countries?.map(value => value.id) ?? [];
        const ids = refineSearchFilters[generalPathname]?.region?.map(value => value.id) ?? [];
        const stateIds = refineSearchFilters[generalPathname]?.state?.map(value => value.id) ?? [];
        const cityIds = refineSearchFilters[generalPathname]?.city?.map(value => value.id) ?? [];
        axios.post(filterLocationUrl, {
            country: [],
            region: [],
            state: [],
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status == 200) {
                setCountryOptions(response.data?.countries?.map(option => ({ ...option, isChecked: countryIds.includes(option.id) })))
                setRegionOptions(response.data?.region?.map(option => ({ ...option, isChecked: ids.includes(option.id) })))
                setStateOptions(response.data.state?.map(option => ({ ...option, isChecked: stateIds.includes(option.id) })))
                setCityOptions(AllCities?.map(option => ({ ...option, isChecked: cityIds.includes(option.id) })))
            }
        }).catch(onErrorHandler)
    }, [refineSearchFilters, AllCities])

    const { primaryMasterId } = useModule();

    const getSearchTags = async (searchText, type) => {
        try {
            const response = await axios.post(tagList, {
                "tag": searchText,
                "type": type,
                "includes_secondary_tags": secondaryTagCheck

            }, {
                headers: {
                    "Authorization": getToken()
                }
            });

            if (response.status === 200) {
                return response.data;
            } else {
                return [];
            }
        } catch (error) {
            return [];
        }
    }


    const fetchData = async () => {
        const tags = await getSearchTags("ALL", "noncompetitor");
        const competitorTags = await getSearchTags("ALL", "competitor")
        const secondaryTags = await getSearchTags("ALL", "secondary")
        // console.log(tags, competitorTags, 'promi')
        openTagModal(tags, competitorTags, secondaryTags)
    };

    const [showDefinitionModal, setShowDefinitionModal] = useState(false);
    const [defValues, setDefValues] = useState({})
    // console.log(defValues, 'showValues');

    const openTagModal = (non_comp, comp, s_tags) => {
        setShowDefinitionModal(true);
        setDefValues({
            non_comp: non_comp,
            comp: comp,
            s_tags: s_tags
        })
    }

    const defCloseHandler = () => {
        setShowDefinitionModal(false);
        setDefValues({})
    }

    const handleDbToggle = () => {
        setDbDropdown(!dbDropdown);
    };

    useEffect(() => {
        setrefineSearchFilters((prev) => ({
            ...prev,
            [generalPathname]: {
                ...prev[generalPathname],
                exitStatus: []
            }
        }))
    }, [])

    const getPeVcSelectedTypes = () => {
        return FirmTypeOptions?.filter(option =>
            (option.id === 1 || option.id === 2) && option.isChecked
        ) || [];
    };

    const [secondaryTagCheck, setSecondaryTagCheck] = useState(true);

    return (
        <div className="bg-white">
            {/* <div className="h-full no-scrollbar"> New Update for responsive design*/}
             <div className="h-full flex flex-col">
                {/* <form onSubmit={refineSearchFilter} onReset={onResetClick} className="h-full w-full"> New Update for responsive design*/}
                <form onSubmit={refineSearchFilter} onReset={onResetClick} className="h-full w-full flex flex-col">
                    <main className="flex-1 w-full py-4 overflow-hidden">
                        {/* <div className="grid grid-cols-8 gap-4 h-full">  New Update for responsive design*/}
                        <div className="h-full flex flex-col md:grid md:grid-cols-8 gap-2 md:gap-4">
                            {/* Left column - Headers */}
                            {/* <div className="h-full col-span-2 flex flex-col gap-2 border-r border-gray-300 pr-4"> New update for responsive design */}
                         <div className="flex flex-row md:flex-col gap-1 md:gap-2 border-b md:border-b-0 md:border-r border-gray-300 pb-2 md:pb-0 md:pr-4 md:max-w-[320px] md:col-span-2 items-center md:items-stretch overflow-hidden flex-wrap md:flex-nowrap no-scrollbar">   
                                {/* <div
                                    className={`cursor-pointer p-3 rounded-lg transition-colors ${activeFilterSection === 'keyword' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                        }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'keyword' ? null : 'keyword')}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-2">
                                            <span className="font-medium">Keyword Search</span>
                                            {getKeywordFiltersCount() > 0 && (
                                                <span className={`text-xs rounded-full px-2 py-1 min-w-[20px] text-center ${activeFilterSection === 'keyword'
                                                        ? 'bg-white text-[#bc8b20]'
                                                        : 'bg-[#bc8b20] text-white'
                                                    }`}>
                                                    {getKeywordFiltersCount()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === 'keyword' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                </div>  */}
                                <div
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${activeFilterSection === 'keyword' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                        }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'keyword' ? null : 'keyword')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Keyword Search</span>
                                        {getKeywordFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'keyword'
                                                ? 'bg-white text-[#bc8b20]'
                                                : 'bg-[#bc8b20] text-white'
                                                }`}>
                                                {getKeywordFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'keyword' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                                <div
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${activeFilterSection === 'deal' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                        }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'deal' ? null : 'deal')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Deal</span>
                                        {getDealFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'deal'
                                                ? 'bg-white text-[#bc8b20]'
                                                : 'bg-[#bc8b20] text-white'
                                                }`}>
                                                {getDealFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'deal' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                                <div
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${activeFilterSection === 'company' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                        }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'company' ? null : 'company')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Company</span>
                                        {getCompanyFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'company'
                                                ? 'bg-white text-[#bc8b20]'
                                                : 'bg-[#bc8b20] text-white'
                                                }`}>
                                                {getCompanyFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'company' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                                <div
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${activeFilterSection === 'investor' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                        }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'investor' ? null : 'investor')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Investor</span>
                                        {getInvestorFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'investor'
                                                ? 'bg-white text-[#bc8b20]'
                                                : 'bg-[#bc8b20] text-white'
                                                }`}>
                                                {getInvestorFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'investor' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                            </div>

                            {/* Right column - Filters (70%) */}
                            {/* <div className="h-full col-span-6 overflow-y-auto"> New update for responsive design */}
                            <div className="col-span-full md:col-span-6 h-full overflow-y-auto overflow-x-hidden md:overflow-y-auto md:overflow-x-hidden md:no-scrollbar mt-4 md:mt-0 pb-4 md:pb-0 relative">
                                {/* <div className={`w-2/4 ${activeFilterSection === 'keyword' ? '' : 'hidden'} relative`}>  new update for resonsive deisgn*/}
                                <div className={`w-full md:w-1/2 ${activeFilterSection === 'keyword' ? '' : 'hidden'} relative flex flex-col overflow-y-auto md:overflow-y-visible md:no-scrollbar`}>
                                    <div className="space-y-4">
                                        <div className="flex items-center gap-4 border border-gray-300 rounded-md p-1 md:gap-2">
                                            <div className="p-0 m-0 bg-white input-search relative flex items-center w-full">
                                                <Tags
                                                    TagsOptions={TagsOptions}
                                                    customPathname={generalPathname}
                                                    setTagsOptions={setTagsOptions}
                                                    getSearchTags={getSearchTags}
                                                    SwitchState={TagSwitchState}
                                                    setSwitchState={setTagSwitchState}
                                                />
                                                <Switch
                                                    SwitchState={TagSwitchState}
                                                    setSwitchState={setTagSwitchState}
                                                    customPathname={generalPathname}
                                                />
                                            </div>
                                            <div className="md:hidden flex items-center">
                                                <Tooltip title='Tag List'>
                                                    <FaInfoCircle
                                                        size={16}
                                                        color="grey"
                                                        className="cursor-pointer px-[1px]"
                                                        onClick={fetchData}
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <div style={{ marginTop: "0.5rem" }} className="mt-2 cursor-pointer flex justify-end items-center text-xs gap-1">
                                            <input type="checkbox" checked={secondaryTagCheck} onChange={() => setSecondaryTagCheck(!secondaryTagCheck)} title="includes secondary tags" />
                                            <span>include secondary tags</span>
                                        </div>
                                        <Tooltip title='Tag List'>
                                            <FaInfoCircle
                                                size={16}
                                                color="grey"
                                                className="cursor-pointer hidden md:block absolute md:left-[107%] md:top-0"
                                                onClick={fetchData}
                                            />
                                        </Tooltip>
                                    </div>
                                    <div className="mt-4 space-y-4">
                                        <Investor
                                            options={InvestorOptions}
                                            setOptions={setInvestorOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(32)}
                                            label="Investor"
                                            open={select === 32}
                                            menu={menu}
                                        />
                                        <TargetCompany
                                            options={TargetCompanyOptions}
                                            setOptions={setTargetCompanyOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(31)}
                                            label="Target Company"
                                            open={select === 31}
                                            menu={menu}
                                        />
                                        <LAdvisor
                                            options={lAdvisorsOptions}
                                            setOptions={setlAdvisorsOptions}
                                            customPathname={generalPathname}
                                            label="Legal Advisors"
                                            accordionClick={() => accordionClick(21)}
                                            open={select === 21}
                                            menu={menu}
                                        />
                                        <TAdvisor
                                            options={tAdvisorsOptions}
                                            setOptions={settAdvisorsOptions}
                                            label="Transaction Advisors"
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(29)}
                                            open={select === 29}
                                            menu={menu}
                                        />
                                    </div>
                                </div>

                                {/* <div className={`grid grid-cols-2 gap-4 gap-y-8 ${activeFilterSection === 'deal' ? '' : 'hidden'}`}> New update for responsive design*/}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:grid-cols-2 md:gap-4 md:gap-y-8 ${activeFilterSection === 'deal' ? '' : 'hidden'}`}>
                                    <StageFilter
                                        StageOptions={StageOptions}
                                        customPathname={customPathname}
                                        setStageOptions={setStageOptions}
                                        accordionClick={() => accordionClick(3)}
                                        open={select === 3}
                                        menu={menu}
                                        isPopupOpen={openFilterPopup === 'stage'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'stage' : null)}
                                    />
                                    <RoundFilter
                                        RoundOptions={RoundOptions}
                                        setRoundOptions={setRoundOptions}
                                        customPathname={customPathname}
                                        accordionClick={() => accordionClick(4)}
                                        open={select === 4}
                                        menu={menu}
                                        isPopupOpen={openFilterPopup === 'round'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'round' : null)}
                                    />
                                    <DealTypeFilter
                                        DealTypeOption={DealTypeOption}
                                        setDealTypeOption={setDealTypeOption}
                                        customPathname={customPathname}
                                        dataPath="investments"
                                        isPopupOpen={openFilterPopup === 'dealType'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'dealType' : null)}
                                    />
                                    <SyndicationFilter
                                        SyndicationOptions={SyndicationOptions}
                                        setSyndicationOptions={setSyndicationOptions}
                                        customPathname={customPathname}
                                        isPopupOpen={openFilterPopup === 'syndication'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'syndication' : null)}
                                    />
                                    <DealsInvolvingFilter
                                        DealsInvolvingOptions={DealsInvolvingOptions}
                                        setDealsInvolvingOptions={setDealsInvolvingOptions}
                                        customPathname={customPathname}
                                        accordionClick={() => accordionClick(9)}
                                        open={select === 9}
                                        isPopupOpen={openFilterPopup === 'dealsInvolving'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'dealsInvolving' : null)}
                                    />
                                    <DealRangeFilter
                                        DealRange={DealRange}
                                        setDealRange={setDealRange}
                                        customPathname={customPathname}
                                        isPopupOpen={openFilterPopup === 'dealRange'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'dealRange' : null)}
                                    />
                                    <ExitStatusFilter
                                        ExitStatusOptions={ExitStatusOptions}
                                        setExitStatusOptions={setExitStatusOptions}
                                        customPathname={customPathname}
                                        dataPath="investments"
                                        isPopupOpen={openFilterPopup === 'exitStatus'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'exitStatus' : null)}
                                    />
                                    <ValuationFilter
                                        ValuationOptions={ValuationOptions}
                                        setValuationOptions={setValuationOptions}
                                        customPathname={customPathname}
                                        isPopupOpen={openFilterPopup === 'valuation'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'valuation' : null)}
                                    />
                                </div>

                                {/* <div className={`grid grid-cols-2 gap-x-6 gap-y-8 ${activeFilterSection === 'company' ? '' : 'hidden'}`}>new update for responsive */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4 md:grid-cols-2 md:gap-x-6 md:gap-y-8 ${activeFilterSection === 'company' ? '' : 'hidden'}`}>
                                    <IndustryFilter
                                        IndustriesOptions={IndustriesOptions}
                                        setIndustriesOptions={setIndustriesOptions}
                                        customPathname={generalPathname}
                                        accordionClick={() => accordionClick(1)}
                                        open={select === 1}
                                        isPopupOpen={openFilterPopup === 'industry'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'industry' : null)}
                                    />
                                    <SectorFilter
                                        SectorOptions={SectorOptions}
                                        setSectorOptions={setSectorOptions}
                                        accordionClick={() => accordionClick(2)}
                                        customPathname={generalPathname}
                                        open={select === 2}
                                        isPopupOpen={openFilterPopup === 'sector'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'sector' : null)}
                                    />
                                    <CompanyTypeFilter
                                        CompanyTypeOptions={CompanyTypeOptions}
                                        setCompanyTypeOptions={setCompanyTypeOptions}
                                        customPathname={customPathname}
                                        accordionClick={() => accordionClick(5)}
                                        open={select === 5}
                                        isPopupOpen={openFilterPopup === 'companyType'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'companyType' : null)}
                                    />
                                    <YearFoundedFilter
                                        EndYearOptions={EndYearOptions}
                                        customPathname={generalPathname}
                                        setEndYearOptions={setEndYearOptions}
                                        StartYearOptions={StartYearOptions}
                                        setStartYearOptions={setStartYearOptions}
                                        isPopupOpen={openFilterPopup === 'yearFounded'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'yearFounded' : null)}
                                    />
                                    <CountryFilter
                                        CountryOptions={CountryOptions}
                                        setCountryOptions={setCountryOptions}
                                        customPathname={generalPathname}
                                        accordionClick={() => accordionClick(10)}
                                        onChange={onCountryChange}
                                        open={select === 10}
                                        isPopupOpen={openFilterPopup === 'country'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'country' : null)}
                                    />
                                    <RegionFilter
                                        RegionOptions={RegionOptions}
                                        setRegionOptions={setRegionOptions}
                                        customPathname={generalPathname}
                                        onChange={onRegionChange}
                                        isPopupOpen={openFilterPopup === 'region'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'region' : null)}
                                    />
                                    <StateFilter
                                        StateOptions={StateOptions}
                                        setStateOptions={setStateOptions}
                                        customPathname={generalPathname}
                                        onChange={onStateChange}
                                        isPopupOpen={openFilterPopup === 'state'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'state' : null)}
                                    />
                                    <CityFilter
                                        CityOptions={CityOptions}
                                        setCityOptions={setCityOptions}
                                        customPathname={generalPathname}
                                        isPopupOpen={openFilterPopup === 'city'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'city' : null)}
                                    />
                                </div>

                                {/* <div className={`grid grid-cols-2 gap-4 gap-y-8 ${activeFilterSection === 'investor' ? '' : 'hidden'}`}> new update for responsive design */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:grid-cols-2 md:gap-4 md:gap-y-8 ${activeFilterSection === 'investor' ? '' : 'hidden'}`}>
                                    <FirmTypeFilter
                                        FirmTypeOptions={FirmTypeOptions}
                                        setFirmTypeOptions={setFirmTypeOptions}
                                        FirmSubTypeOptions={FirmSubTypeOptions}
                                        setFirmSubTypeOptions={setFirmSubTypeOptions}
                                        customPathname={generalPathname}
                                        dataPath="investments"
                                        isPopupOpen={openFilterPopup === 'firmType'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'firmType' : null)}
                                    />
                                    <InvestorHeadquartersFilter
                                        HeadquartersOptions={HeadquartersOptions}
                                        setHeadquartersOptions={setHeadquartersOptions}
                                        customPathname={generalPathname}
                                        setHeadquarterCityOptions={setHeadquarterCityOptions}
                                        HeadquarterCityOptions={HeadquarterCityOptions}
                                        isPopupOpen={openFilterPopup === 'investorHeadquarters'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'investorHeadquarters' : null)}
                                    />
                                    <InvestorTypeFilter
                                        InvestorTypeOptions={InvestorTypeOptions}
                                        setInvestorTypeOptions={setInvestorTypeOptions}
                                        customPathname={generalPathname}
                                        isPopupOpen={openFilterPopup === 'investorType'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'investorType' : null)}
                                    />
                                </div>

                                {!activeFilterSection && (
                                    <div className="flex items-center justify-center h-40 text-gray-500">
                                        <p>Select a filter category from the left to view available filters</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </main>
                </form>
            </div>
            {showDefinitionModal && 
                <DefinitionModal 
                    values={defValues}
                    onClose={defCloseHandler}
                    TagsOptions={TagsOptions}
                    customPathname={generalPathname}
                    setTagsOptions={setTagsOptions} 
                />}
        </div>
    );
}


